import { render } from "./JsonLd.vue?vue&type=template&id=0ea84cf0"
import script from "./JsonLd.vue?vue&type=script&lang=js"
export * from "./JsonLd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__